<template>
	<div>
		<div v-if="isMappingSetupFinished">
			<div class="application-source-selection">
				<div v-for="param in paramsToShow" :key="param.key">
					<ParamDispatcherDataProvider v-bind="$attrs" v-on="$listeners" :node="node" :param="param" :key="buildFieldKeyFunc(param)" />
					<AppLoader v-if="loadingExtraParams" />
				</div>
			</div>
			<div class="choose-params pt-8">
				<div class="required-fields-hint" v-if="hasRequiredParams">there are required fields that need to be mapped and filled</div>
				<div v-if="paramsChoiceOptions.length > 0">
					<AppSelect
						class="more-fields"
						item-text="name"
						naked
						dense
						v-model="chosenParam"
						:items="paramsChoiceOptions"
						return-object
						@change="onChange"
						label="+ Add properties"
						:readonly="!hasEditPermissions"
					>
						<template v-slot:item="{ item }">
							<div class="flex-column option">
								<div class="text">
									{{ item.name }}<span v-if="item.required" class="required px-6">[required]</span
									><span v-if="isFilled(item.key)" class="filled px-6">[filled and needs to be mapped]</span>
								</div>
							</div>
						</template>
					</AppSelect>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import ParamsService from '@/utils/ParamsService';
import DynamicDataService from '@/utils/dynamic-data-service';
import { getWidgetFieldData } from '@/store/modules/widgets/getters';
import { loadingExtraFields } from '@/store/modules/selectedNode/getters';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import ParamDispatcherDataProvider from '@/components/BlockEditor/BlockEditorParams/ParamDispatcherDataProvider';
import { isNullOrUndefinedOrEmpty } from '@/utils/helpers';
export default {
	name: 'DynamicParamsWriteActionDispatcher',
	props: {
		node: { type: Object },
		service: { type: Object },
		action: { type: Object },
		params: { type: Array },
		buildFieldKeyFunc: { type: Function },
		hasEditPermissions: { type: Boolean },
	},
	components: {
		ParamDispatcherDataProvider,
	},
	computed: {
		...mapGetters([getWidgetFieldData.fullPath, loadingExtraFields.fullPath]),
		loadingExtraParams() {
			return this[loadingExtraFields.fullPath];
		},
		alreadyChosenByMapperParamsKeys() {
			return ParamsService.getParamsForMapping(this.service, this.action).map((p) => p.key);
		},
		skipMappingKeys() {
			return ParamsService.getSkipKeysForMapping(this.service, this.action);
		},
		paramsThatDoNotNeedMappingKeys() {
			return this.params?.filter((p) => this.skipMappingKeys.includes(p.key)).map((x) => x.key);
		},
		chosenParamsKeys() {
			return this.chosenParams.map((x) => x.key);
		},
		widgetFieldData() {
			return this[getWidgetFieldData.fullPath](this.node.user_schema_mappings_source_field_uuid) || {};
		},
		mapperData() {
			return this.widgetFieldData.widgetField || {};
		},
		mapperMappings() {
			return this.mapperData?.metadata?.source?.mappings || [];
		},
		mapperMappingsKeys() {
			return this.mapperMappings.map((x) => x.originalKey);
		},
		paramsToShow() {
			return [
				...this.params?.filter(
					(p) =>
						(this.mapperMappingsKeys.includes(p.key) || this.paramsThatDoNotNeedMappingKeys.includes(p.key)) &&
						!this.alreadyChosenByMapperParamsKeys.includes(p.key)
				),
				...this.chosenParams,
			];
		},
		paramsChoiceOptions() {
			return this.params?.filter(
				(p) =>
					!this.alreadyChosenByMapperParamsKeys.includes(p.key) &&
					!this.mapperMappingsKeys.includes(p.key) &&
					!this.chosenParamsKeys.includes(p.key) &&
					!this.paramsThatDoNotNeedMappingKeys.includes(p.key)
			);
		},
		hasRequiredParams() {
			return this.paramsChoiceOptions.some((x) => x.required);
		},
		isMappingSetupFinished() {
			return DynamicDataService.isMappingSetupFinished(this.mapperData, this.service);
		},
	},
	methods: {
		async onChange(value) {
			this.chosenParam = null;
			await AppDialogManagerService.openAddMappingToMapperDialog({
				service: this.service,
				originalKey: value.key,
				widgetFieldUUID: this.node.user_schema_mappings_source_field_uuid,
			});
			// if successfully mapped add to options
			if (this.mapperMappings.some((x) => x.originalKey == value)) {
				this.chosenParams.push(value);
			}
		},
		isFilled(key) {
			return !isNullOrUndefinedOrEmpty(this.node?.params_map?.[key]);
		},
	},
	data() {
		return {
			chosenParam: null,
			chosenParams: [],
		};
	},
};
</script>

<style lang="scss" scoped>
.choose-params {
	font-size: 11px;
}
.required-fields-hint {
	color: grey;
	font-size: 10x;
}
.more-fields {
	background: var(--bg-color);
	border: 1px dashed var(--primary-color);
	.v-select.v-text-field input {
		color: var(--bg-color) !important;
	}
}
.option {
	font-size: 14px;
}
.required {
	font-size: 11px;
	color: rgb(233, 93, 101);
}
.filled {
	color: grey;
	font-size: 11px;
}
</style>
